import {
  FINANCIAL_ACCESS,
  RECORD_PERMISSION,
  USER_ROLES,
  USER_STATUS,
  USER_TYPE,
} from '@/constants/enums/USER_PERMISSIONS'
import { isSubfoldersEnabledInConfig } from '@/utils/fileSubfolders'

export default {
  rolesOptions: () => USER_ROLES.map(({ name, slug }) => ({ label: name, value: slug })),
  statusesOptions: () => USER_STATUS.map(({ name, slug }) => ({ label: name, value: slug })),
  userFinancialAccess:
    ({ currentUser }) => currentUser ? currentUser.financialAccess.slug === FINANCIAL_ACCESS.full : false,
  isAdmin: ({ currentUser }) => {
    return currentUser?.type === USER_TYPE.internal && currentUser?.isAdmin
  },
  isStandard: ({ currentUser }) => {
    return currentUser?.type === USER_TYPE.internal
  },
  // False when the company's dashboards are all private and the user is not on
  // any access list (Admin > Dashboard), and while the profile is not loaded.
  canAccessDashboard: ({ currentUser }) => Boolean(currentUser?.canAccessDashboard),
  isViewCollaborator: (store, { recordAccess }) => {
    return recordAccess?.slug === RECORD_PERMISSION.viewCollaborator
  },
  isViewAll: (store, { recordAccess }) => {
    return recordAccess?.slug === RECORD_PERMISSION.viewAll
  },
  recordAccess: ({ currentUser }) => {
    return currentUser?.recordAccess || false
  },
  editCollaboratorRecords: (store, { recordAccess }) => {
    return recordAccess?.slug === RECORD_PERMISSION.editCollaborator
  },
  editAllRecords: (store, { recordAccess }) => {
    return recordAccess?.slug === RECORD_PERMISSION.editAll
  },
  getObjectChildren: ({ config }) => config?.quoteCustomFieldObjectAggregations?.items || [],
  getFinancialAccess: ({ permissions }) => permissions?.financial_access?.map((item) => ({
    value: item.slug,
    label: item.name,
  })) || [],
  getRecordPermission: ({ permissions }) => permissions?.record_access?.map((item) => ({
    value: item.slug,
    label: item.name,
  })) || [],
  isRecordTypesEnabled: ({ config }) => config?.recordTypes.display || false,
  isESignEnabled: ({ config }, { eSignType }) => (config?.eSign?.display && eSignType !== 'innactive') || false,
  eSignType: ({ config }) => config?.eSign?.type || 'innactive',
  isTaskWidgetEnabled: ({ config }) => config?.taskWidget?.display || false,
  isNotificationsWidgetEnabled: ({ config }) => config?.notification_widget?.display || false,
  isRecordFormulasEnabled: ({ config }) => config?.recordFormulas?.display || false,
  isOutlookIntegrationEnabled: ({ config }) => {
    return config?.displayOutlookIntegration?.display || false
  },
  isNeedShowOutlookReconnect: ({ currentUser }, { isOutlookIntegrationEnabled }) => {
    return isOutlookIntegrationEnabled
      && currentUser?.outlookIntegration?.connected
      && !currentUser?.outlookIntegration?.active
  },
  isAiSummaryEnabled: ({ config }) => config?.displayAISummary?.display || false,
  isVFormsEnabled: ({ config }) => config?.displayVforms?.display || false,
  isVaiWebSearchEnabled: ({ config }) => config?.vaiWebSearch?.display || false,
  isSubfoldersEnabled: ({ config }) => isSubfoldersEnabledInConfig(config),
  recordFormulas: ({ config }) => config?.recordFormulas?.items || [],
  userExternalId: ({ currentUser }) => currentUser?.externalId || '',
  recordHelpField: ({ config }) => config?.preorders?.title?.helpField || [],
  recordTitle: ({ config }) => {
    return config
      && config.preorders.title
      && config.preorders.title.custom.singular || 'Record'
  },
  recordsTitle: ({ config }) => {
    return config
      && config.preorders.title
      && config.preorders.title.custom.plural || 'Records'
  },
}
